import { FaFileSignature } from "react-icons/fa";

const ChargeType = () => {
  return <FaFileSignature size={23} className="sidebar-icon" />;
};

export default ChargeType;
